import { useTranslation } from 'react-i18next';

import i18n from '@/i18n/config';
import { Language, Locale } from '@/types';

export const getCurrentLocale = (): Locale => {
  const locale = i18n.language as Locale;
  return locale;
};

export function useCurrentLanguage(): Language {
  const { i18n } = useTranslation();

  switch (i18n.language) {
    case 'es_ES':
      return 'es';

    case 'en_US':
      return 'en';

    case 'ca_CA':
      return 'ca';

    case 'eu_EU':
      return 'eu';

    default:
      return 'es';
  }
}

export function getLocaleFromString(language: string): Locale | null {
  switch (language) {
    case 'es_ES':
      return 'es_ES';

    case 'en_US':
      return 'en_US';

    case 'ca_CA':
      return 'ca_CA';

    case 'eu_EU':
      return 'eu_EU';
  }

  return null;
}
